import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=b2c75748&scoped=true"
import script from "./DocumentTable.vue?vue&type=script&lang=ts"
export * from "./DocumentTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=b2c75748&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c75748",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2c75748')) {
      api.createRecord('b2c75748', component.options)
    } else {
      api.reload('b2c75748', component.options)
    }
    module.hot.accept("./DocumentTable.vue?vue&type=template&id=b2c75748&scoped=true", function () {
      api.rerender('b2c75748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentTable.vue"
export default component.exports